import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { base } from "wagmi/chains";

export const wagmiConfig = getDefaultConfig({
  appName: "Espectro",
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ?? "espectro-dev",
  chains: [base],
});
